<template>
  <ProgramKeyIndicatorContainer>
    <div
      class="flex flex-1 flex-col"
    >
      <div class="flex flex-1 items-center">
        <div class="flex flex-1 flex-col mx-5 gap-4">
          <div>{{ data.label }}</div>
          <div class="flex gap-3 justify-center w-full">
            <div class="flex flex-1 flex-col text-primary font-bold text-3xl items-center pr-2 border-r">
              <div class="text-xs">
                Cette année
              </div>
              {{ data.value.current }}
            </div>
            <div class="flex flex-1 flex-col text-3xl items-center text-[#718AFF] pr-2 border-r">
              <div class="text-xs">
                Précédente
              </div>
              {{ data.value.previous }}
            </div>
            <div v-if="data.value.delta <= 0" class="flex flex-1 flex-col text-red text-xs items-center">
              <Icon name="mdi-arrow-down" :size="35" class="text-red" />
              <div class="text-red">
                {{ data.value.delta }}
              </div>
            </div>
            <div v-else class="flex flex-1 flex-col justify-center text-xs items-center">
              <div class="text-success">
                {{ data.value.delta }}
              </div>
              <Icon name="mdi-arrow-up" :size="35" class="text-success" />
            </div>
          </div>
        </div>
      </div>
      <span v-if="data.extra" class="text-sm text-apodis mt-3">{{ data.extra }}</span>
    </div>
  </ProgramKeyIndicatorContainer>
</template>

<script lang="ts" setup>
import Icon from "@/core/components/icon/Icon.vue";
import {GrowthStatistics} from "@/program/interfaces/Program";
import ProgramKeyIndicatorContainer from "@/program/components/program-statistics/ProgramKeyIndicatorContainer.vue";

defineProps<{
    data: GrowthStatistics
}>();
</script>
